import React from "react";
import {axiosInstance} from "../../Api/AxiosConfig";
import {ShoppingBagIcon, ShoppingCartIcon} from "@heroicons/react/24/outline";
import {CheckIcon} from "@heroicons/react/24/solid";
import {CarzelleTooltip} from "../System/Messages/CarzelleTooltip";


export const SizeEnum = Object.freeze({
    Small: 'Small',
    Big: 'Big'
});

export const AddToBasketButton = React.memo(({car, fnUpdate, tooltip, className, size = SizeEnum.Small, bgColor = 'bg-purchase-color'}) => {
    const addItemToBasket = (hash) => {
        axiosInstance
            .post("shop/add-to-basket", {carHash: hash})

            .then(() => {
                fnUpdate();
            })
            .catch((error) => {
                console.error("Error adding car to basket:", error);
            });
    }

    const deleteItem = (hash) => {
        axiosInstance
            .delete("shop/remove-from-basket/" + hash)

            .then(() => {
                fnUpdate();
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }

    const handleButtonClick = (e) => {
        e.stopPropagation();
        if (car.in_basket !== null) {
            deleteItem(car.hash);
            return;
        } else {
            addItemToBasket(car.hash);
        }
    }

    let buttonText = null;
    if (car.in_basket && size === SizeEnum.Big) {
        buttonText = "Remove from Basket";
    } else {
        buttonText = car.buy_status !== 'listing' && !car.counter_offer ? "Buy now" : car.counter_offer === 1 ? 'Accept Offer' : null;
    }

    return (
        <CarzelleTooltip message={tooltip}>
            <div>
                {size === SizeEnum.Small &&
                    <button
                        className={`relative rounded-lg ${!buttonText ? 'px-6' : 'px-2'} h-[30px] flex items-center justify-center hover:scale-[1.15] duration-300 ` + className + ' ' + (car.in_basket !== null ? ' bg-un-purchase-color' : ' ' + bgColor)}
                        onClick={handleButtonClick}
                    >
                        {!buttonText && car.in_basket &&
                            <div className="absolute top-3 right-3"><CheckIcon className={`w-3 h-3`}/></div>
                        }
                        {buttonText && car.in_basket &&
                            <div className="absolute top-0 right-0"><CheckIcon strokeWidth={2} className={`w-3 h-3`}/></div>
                        }
                        {!buttonText &&
                            <span className={"flex material-symbols-outlined text-[20px] " + (car.in_basket !== null ? ' text-gray-400' : 'text-white ')} title={tooltip}>
                            <ShoppingBagIcon className="w-5 h-5"/>
                        </span>
                        }
                        {buttonText &&
                            <span className={`text-xs whitespace-nowrap ${car.in_basket !== null ? 'text-gray-400' : 'text-white'}`}>
                            {buttonText}
                        </span>
                        }
                    </button>
                }
                {size === SizeEnum.Big &&
                    <button onClick={handleButtonClick} className={`${car.in_basket ? 'bg-blue-200' : 'bg-purchase-color'} rounded-xl text-white w-full p-3 flex justify-center`}>
                        <div className="flex items-center">
                            <div><ShoppingCartIcon className="w-6 h-6 mr-4"/></div>
                            <div>{buttonText}</div>
                        </div>
                    </button>
                }
            </div>
        </CarzelleTooltip>
    )
});
